import { render, staticRenderFns } from "./MenuShowPage.vue?vue&type=template&id=202faca3&scoped=true&"
import script from "./MenuShowPage.vue?vue&type=script&lang=js&"
export * from "./MenuShowPage.vue?vue&type=script&lang=js&"
import style0 from "./MenuShowPage.vue?vue&type=style&index=0&id=202faca3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202faca3",
  null
  
)

export default component.exports